import React from "react";
import Project from "./projetEtp";

export function ProjectInProgress() {
  return <Project status="En cours" />;
}